var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCircledCheckmarkFill = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "25px",
  height: "25px",
  viewBox: "0 0 25 25",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref,
  "aria-labelledby": titleId
}, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, "Group 2082 Copy 3") : title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Time-Clock",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Timeclock--Summary",
  transform: "translate(-102.000000, -500.000000)",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-7",
  transform: "translate(28.000000, 362.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-8",
  transform: "translate(15.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2082-Copy-3",
  transform: "translate(60.000000, 139.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  stroke: "#46CC88",
  fill: "#46CC88",
  fillRule: "nonzero",
  cx: 11.2230417,
  cy: 11.2230417,
  r: 11.2230417
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Path",
  stroke: "#FFFFFF",
  points: "5.49076125 10.8649125 9.79004583 15.1642833 17.313825 7.64046583"
}))))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCircledCheckmarkFill);
export default ForwardRef;